module.exports = __webpack_public_path__ + "static/media/logo.0bd3bda0.png";